import { Outlet } from "react-router-dom";
import AppShell from "components/app/AppShell";

const UserProfileLayout = () => {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
};

export default UserProfileLayout;
